import { render, staticRenderFns } from "./IosDeviceDetail.vue?vue&type=template&id=5d584508&scoped=true"
import script from "./IosDeviceDetail.vue?vue&type=script&lang=js"
export * from "./IosDeviceDetail.vue?vue&type=script&lang=js"
import style0 from "./IosDeviceDetail.vue?vue&type=style&index=0&id=5d584508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d584508",
  null
  
)

export default component.exports